// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import styles from './CarouselProgress.less';

/** Component props for <CarouselProgress /> */
export type Props = {|
  /** The current index (1 based) of the item that is being displayed */
  currentIndex: number,
  /** The total number of items that are available to display */
  numItems: number,
|};

const CarouselProgress = (props: Props) => (
  <div className={styles.container}>
    <span className={styles.text}>
      {/* currentIndex / numItems */}
      {localize('carousel_progress_numbers', {
        photos: props.currentIndex,
        totalPhotos: props.numItems,
      })}
    </span>
  </div>
);

export default CarouselProgress;
